import { isRenderingForMobileApp } from 'src/constants';
import { FunnelSource } from '~services/trx/events';

export class Utils {
  public static isValidDate(date: any): boolean {
    if (Object.prototype.toString.call(date) === '[object Date]') {
      return !isNaN(date.getTime());
    }

    return false;
  }

  public static checkValid(value: any, lengthCheck: boolean = true): boolean {
    if (typeof value !== 'undefined' && value !== null) {
      const stringValue = value.toString();

      if (typeof value === 'function' || typeof value === 'object') {
        if (lengthCheck) {
          return !(typeof value.length !== 'undefined' && value.length <= 0);
        }

        return true;
      }

      if (this.isValidDate(value)) {
        return true;
      }

      if (typeof value === 'boolean') {
        return value;
      }

      if (/\S/.test(stringValue) && !isNaN(stringValue)) {
        return true;
      }

      if (/\S/.test(stringValue)) {
        return true;
      }
    }

    return false;
  }

  public static setLocalStorage(key: string | string[], value: string): void {
    if (typeof key === 'string') {
      window.localStorage.setItem(key, value);
    }

    if (Array.isArray(key)) {
      for (const itemKey of key) {
        window.localStorage.setItem(itemKey, value);
      }
    }
  }

  public static getLocalStorage(key: string | string[]): string | null {
    if (typeof key === 'string') {
      return window.localStorage.getItem(key);
    }

    if (Array.isArray(key)) {
      for (const itemKey of key) {
        const value = window.localStorage.getItem(itemKey);
        if (value) {
          return value;
        }
      }
    }

    return null;
  }

  public static redirect(path: string) {
    if (path) {
      const redirectUrl = new URL(window.location.href);
      redirectUrl.pathname = path;
      redirectUrl.search = window.location.search;
      window.location.href = redirectUrl.href;
    }
  }

  public static scrollToSmooth(target: any) {
    let scrollContainer = target;

    do {
      //find scroll container
      scrollContainer = scrollContainer.parentNode;
      if (!scrollContainer) return;
      scrollContainer.scrollTop += 1;
    } while (scrollContainer.scrollTop == 0);

    let targetY = 0;
    do {
      //find the top of target relatively to the container
      if (target == scrollContainer) break;
      targetY += target.offsetTop;
    } while ((target = target.offsetParent));

    let scroll = (c: any, a: any, b: any, i: any) => {
      i++;
      if (i > 30) return;
      c.scrollTop = a + ((b - a) / 30) * i;
      setTimeout(() => {
        scroll(c, a, b, i);
      }, 20);
    };
    // start scrolling
    scroll(scrollContainer, scrollContainer.scrollTop, targetY, 0);
  }

  public static getScriptInHead(scriptId: string) {
    return document.getElementById(scriptId);
  }

  public static setScriptInHead(scriptId: string, scriptType: string, scriptContent: string) {
    const script = document.createElement('script');
    script.setAttribute('type', scriptType);
    script.id = scriptId;
    script.textContent = scriptContent;
    document.head.appendChild(script);
  }

  public static removeScriptInHeadById(scriptId: string) {
    var head = document.getElementsByTagName('head')[0];
    var script = document.getElementById(scriptId);
    if (script != null) {
      head.removeChild(script);
    }
  }

  public static getFunnelSource(): FunnelSource | null {
    if (isRenderingForMobileApp) {
      if (window.location.href.includes('/checkout')) {
        return FunnelSource.ShopFeed;
      }
      return FunnelSource.MobileNav;
    }

    if (document.referrer.includes('zip.co')) {
      return FunnelSource.WebNav;
    }

    return null;
  }
}
